import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "LStudio__project_access";

const EVENT_NAME = "LStudio__project_access_change";

const onReadStore = () => {

    try {
        return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) ?? "{}");
    } catch {
        return {};
    }
};

const onWriteStore = (store) => {

    try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch {
        return;
    }

    window.dispatchEvent(new Event(EVENT_NAME));
};

export const PROJECT_ACCESS = {

    read(projectId) {
        return onReadStore()[projectId] ?? null;
    },

    unlock(projectId, accessPin) {
        onWriteStore({ ...onReadStore(), [projectId]: accessPin });
    },

    lock(projectId) {
        const STORE = onReadStore();
        delete STORE[projectId];
        onWriteStore(STORE);
    },

};

export const useProjectAccess = (projectId) => {

    const [useAccessPin, setAccessPin] = useState(() => (projectId ? PROJECT_ACCESS.read(projectId) : null));

    useEffect(() => {

        const onSync = () => setAccessPin(projectId ? PROJECT_ACCESS.read(projectId) : null);

        onSync();

        window.addEventListener(EVENT_NAME, onSync);
        return () => window.removeEventListener(EVENT_NAME, onSync);

    }, [projectId]);

    const onUnlock = useCallback((accessPin) => PROJECT_ACCESS.unlock(projectId, accessPin), [projectId]);

    const onLock = useCallback(() => PROJECT_ACCESS.lock(projectId), [projectId]);

    return { useAccessPin, onUnlock, onLock };
};
